module.exports = __webpack_public_path__ + "static/media/agent.d36eae52.svg";